<template>
  <div class="circle-of-lights" ref="circles">
    <!-- 画布将挂载在此容器中 -->
    <div class="wid100 hei100 Center" ref="canvasContainer"></div>
  </div>
</template>

<script>

export default {
  name: "CircleOfLights",
  data() {
    return {
      p5Instance: null,
    };
  },
  mounted() {
    // p5 sketch 定义：使用实例模式
    const sketch = (p) => {

      let particles = [];
      const amount = 80; // 粒子数量
      const durationShrink =5; // 缩小动画持续时间
      const durationGrow = 5; // 扩大动画持续时间
      const total = durationShrink + durationGrow; // 总动画时长
      const theme = ['#bb2c00', '#c0490a', '#c57506', '#c94002']; // 颜色主题
      const w_width = this.$refs.circles
      // 用于动画控制的代理对象
      const proxy = {
        progress: 1,
        val:0
      };

      let interpolator;
      let progressTween;

      // 创建单个粒子对象
      function createParticle(i) {
        return {
          i: i,
          cos: p.cos(i * p.TWO_PI),
          sin: p.sin(i * p.TWO_PI),
          r: p.floor(p.random(2, 5)),
          offset: Math.pow(p.random(2, 3), 1.5) * p.random(-0.015, 0.015),
          color: p.random(theme),
          draw: function() {

            // 控制动画进度
            interpolator.progress((proxy.progress + this.i) % 1);
            let r = p.width * (0.395 + (proxy.val * this.offset));
            let x = this.cos * r + p.width / 2;
            let y = this.sin * r + p.width / 2;
            p.fill(this.color);
            p.circle(x, y, this.r);
          }
        };
      }

      p.setup = function() {
        // 画布大小取窗口最小边尺寸

      // console.log(windowWidth)

        const size = p.min(w_width.offsetWidth*1.2, w_width.offsetWidth*1.2);
        p.createCanvas(size, size);
        p.noStroke();
        // 非 Firefox 浏览器使用 SCREEN 混合模式
        if (navigator.userAgent.indexOf('Firefox') < 0) {
          p.blendMode(p.SCREEN);
        }
        // 创建所有粒子
        for (let i = 0; i < amount; i++) {
          particles.push(createParticle(i / amount));
        }
        // 初始化 GSAP 动画：圆形路径的进度控制
        progressTween = gsap.to(proxy, {
          progress: 0,
          ease: "none",
          duration: total,
          repeat: -1
        });
        // 初始化 GSAP 插值动画：粒子大小的变化
        interpolator = gsap.timeline({
          paused: true,
          reverse: true
        })
          .to(proxy, {
            val: 1,
            duration: durationShrink,
            ease: 'back.in(3)'
          })
          .to(proxy, {
            val: 0,
            duration: durationGrow,
            ease: 'back.in(3)'
          });
      };

      p.windowResized = function() {
        const size = p.min(w_width.offsetWidth*1.2, w_width.offsetWidth*1.2);
        p.resizeCanvas(size, size);
      };

      p.draw = function() {
        p.clear(); // 清空画布

        particles.forEach(particle => {
          particle.draw();
        });
        // p.filter(p.BLUR, 2); // 数值/可根据需求调整
      };
    };

    // 在容器中挂载 p5 实例

      this.p5Instance = new p5(sketch, this.$refs.canvasContainer);


  },
  beforeDestroy() {
    // 清除 p5 实例，避免内存泄漏
    if (this.p5Instance) {
      this.p5Instance.remove();
    }
  }
};
</script>

<style scoped>
.circle-of-lights {
  margin: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  top:0;left: 0;
}

canvas {

  /*touch-action: none;*/
  /*filter: drop-shadow(0px 0 3px rgba(0, 228, 233, 0.7)); !* 画布阴影效果 *!*/
  /*width: 100%; height: 100%;*/
  /*margin: -50px 0 0 -50px;*/
}
</style>
<style>
.p5Canvas{}
.circle-of-lights {
  margin: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  top:0;left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ParticleSystem02.vue